import Axios from "@/plugins/Axios";

export class PresencasService {
  async getPresencasNotifiqHikvision({ date, horario_id, turma_id }) {
    const response = await Axios().post(
      `notifiq/presencas/get-presencas-hikvision`,
      { date, horario_id, turma_id },
      { timeout: 15000 }
    );
    return response;
  }

  async getPresencasHikvision({ matricula_id, data, evento } = {}) {
    const response = await Axios().get(`notifiq/presencas/presencas-hikvision`, {
      params: { matricula_id, data, evento },
    });
    return response.data;
  }
}

export default new PresencasService();
